import { get } from "lodash";
import { IFileUpload } from "../../components/FileUpload/FileUpload.type";
import { LoadState } from "../../constants/enums";
import { getUniqueId } from "../../helpers";

export interface IAuctionState {
  auction: {
    list: IAuction[];
    loading: LoadState;
    totalRecords: number;
    data: IAuction;
    dataLoading: LoadState;
    error: string | null;
  };
  auction_product: {
    list: IAuctionProduct[];
    loading: LoadState;
    totalRecords: number;
    data: IAuctionProduct;
    dataLoading: LoadState;
    error: string | null;
  };
    auction_linked_product: {
    list: IAuctionLinkedProduct[];
    loading: LoadState;
    totalRecords: number;
    data: IAuctionLinkedProduct;
    dataLoading: LoadState;
    error: string | null;
  };
}

export interface IAuctionLinkedProduct {
  auction_linked_products_uuid: string | null;
  auction_uuid: string | null;
  auction_product_uuid: string | null;
  biding_auction_base_price: string | null;
  status: string;
}

export interface IAuctionproducts {
  key: string;
  product_name: string;
  product_base_price: string;
  auction_product_uuid: string;
  product_images?: IFileUpload[]; 
  vehicle_model?: string;
  vehicle_make?: string;
  vehicle_year?: string;
  vehicle_color?: string;
  mileage?: string;
  fuel_type?: string;
  transmission?: string;
  // transmission?: string;
}
export interface IAuction {
  auction_id: string | null;
  auction_unique_id: string | null;
  auction_uuid: string | null;
  auction_title: string | null;
  start_time: string | null;
  end_time: string | null;
  is_published: number | null;
  status: string | null;
  auction_linked_products: IAuctionproducts[] | null;
  vehicle_model: string | null;
  product_features: {
    mileage?: string; 
    feature?: string; 
    [key: string]: any; 
    product_reference_name?: string;
    product_reference_value?: string;
  }

}
export interface IAuctionProductFeatures {
  mileage?: string; 
  feature?: string; 
  [key: string]: any; 
}

export interface IAuctionProductImages{
  album_uuid: string;
  album_name: string;
  images: string[];
}
export const defaultAuctionProductImage:IAuctionProductImages={
album_uuid: "default-album-1",
album_name:"default",
images:[]};
export interface IAuctionProduct {
  auction_product_id: string | null;
  auction_product_uuid: string | null;
  auction_product_unique_id: string | null;
  product_name: string | null;
  product_category: string | null;
  product_sub_category: string | null;
  vehicle_make: string | null;
  vehicle_model?: string | null;
  product_reference_name: string | null;
  product_reference_value: string | null;
  product_base_price: string | null;
  product_description: string | null;
  product_features: IAuctionProductFeatures;
  product_images: IAuctionProductImages[];
  evaluation: number;
  sell_status: string | null;
  address: string | null;
  rating: string | null;
  product_verification: string | null;
  status: string;
  fuel_type: string;
  transmission: string;
  mileage: string;
  owner: string;
  exterior_rating?: string | number;
  interior_rating?: string | number;
  tyres_rating?: string | number;
  suspension_and_brakes_rating?: string | number;
  electricals_rating?: string | number;
  air_conditioners_rating?: string | number;
  rc_status?: string;
  body_type?: string;
  kms_driven?: string;
  location?: string;
  year_of_manufacturing?: string;
  comfort_and_convenience?: Record<string, any>;
  locks_and_security?: Record<string, any>;
  seats_and_upholstery?: Record<string, any>;
  safety_and_security?: Record<string, any>;
  lights?: Record<string, any>;
  manufacturer_warranty?: Record<string, any>;
  engine_performance?: Record<string, any>;
  capacity?: Record<string, any>;
  dimensions_and_weights?: Record<string, any>;
  Suspension_brakes_steering?: Record<string, any>;
  exterior_remark?: string;
  interior_remark?: string;
  tyres_remark?: string;
  suspension_and_brakes_remark?: string;
  electricals_remark?: string;
  air_conditioners_remark?: string;
  overall_rating?: string;
}

export const initialAuctionProducts: IAuctionproducts = {
  key: getUniqueId(),
  product_name: "",
  product_base_price: "",
  auction_product_uuid: "",
  product_images: [],
}
export const initialAuctionState: IAuctionState = {
  auction: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    data: {
      auction_id: null,
      auction_title: null,
      auction_unique_id: null,
      auction_uuid: null,
      end_time: null,
      is_published: 0,
      status: "ACTIVE",
      auction_linked_products: [],
      start_time: null,
      vehicle_model: null,
  product_features: {
    mileage: "",
    feature: "",
    product_reference_name: "Vehcile Number",
    product_reference_value: "",

  },
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  auction_product: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    data: {
      address: null,
      auction_product_unique_id: null,
      auction_product_uuid: null,
      evaluation: 0,
      product_base_price: null,
      product_category: null,
      product_description: null,
      product_features: {},
      product_images: [],
      product_name: null,
      auction_product_id: null,
      product_reference_name: "Vehcile Number",
      product_reference_value: null,
      product_sub_category: null,
      product_verification: null,
      rating: null,
      sell_status: null,
      status: "ACTIVE",
      vehicle_make: null,
      vehicle_model: null,
      fuel_type: "",
      transmission: "",
      mileage: "",
      owner: "",
      exterior_rating: "",
      interior_rating: "",
      tyres_rating: "",
      suspension_and_brakes_rating: "",
      electricals_rating: "",
      air_conditioners_rating: "",
      rc_status: "",
      body_type: "",
      kms_driven: "",
      location: "",
      year_of_manufacturing: "",
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  auction_linked_product: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    data: {
      auction_linked_products_uuid: null,
      auction_product_uuid: null,
      auction_uuid: null,
      biding_auction_base_price: null,
      status: "ACTIVE",
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
};
